module.exports = __webpack_public_path__ + "img/airwaysplus.e9cc0f32.svg";